import React from 'react';
import Button from '../../ui/Button';

const ReturnActionButtons = ({
  allHaveLabels,
  isGeneratingLabel,
  isCancellingReturn,
  onCancelReturn,
  onBack,
  onDone
}) => {
  return (
    <div className="flex justify-between mt-6">
      <div>
        {/* Cancel Return Button */}
        {!allHaveLabels && !isGeneratingLabel && (
          <Button
            variant="danger"
            onClick={onCancelReturn}
            disabled={isGeneratingLabel || isCancellingReturn}
          >
            Cancel Return
          </Button>
        )}
      </div>
      <div className="flex space-x-4">
        <Button
          variant="secondary"
          onClick={onBack}
          disabled={isGeneratingLabel}
        >
          Back
        </Button>
        
        {/* {allHaveLabels && (
          <Button
            variant="primary"
            onClick={onDone}
          >
            Done
          </Button>
        )} */}
      </div>
    </div>
  );
};

export default ReturnActionButtons; 